import React, { useEffect, useState } from "react";
import { getServices } from "../api/serviceService";
import { sleep } from "../utils/sleep";
import * as FaIcons from 'react-icons/fa';

const Services = () => {
  const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
      useEffect(() => {
      const fetchServices = async () => {
        try {
          // simulate network delay (3 sec)
          //await sleep(3000);
  
          const data = await getServices(); // asynchronous call
          setServices(data);
        } catch (err) {
          setError("Failed to load services.");
        } finally {
          setLoading(false);
        }
      };
  
      fetchServices();
      }, []);
    
    // Loading Overlay
    if (loading) {
      return (
        <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <span className="ms-3 fw-semibold">Loading services...</span>
        </div>
      );
    }
    
     // Error Message
    if (error) {
      return (
        <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
          <p className="text-danger fs-7">{error}</p>
          <button
            className="btn btn-outline-primary mt-3"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      );
  }
  
  return (
    <section className="services-section py-5">
      <div className="container text-center">
        <h2 className="mb-4 fw-bold">Our <span className="text-primary-color">Services</span></h2>
        <p className="text-muted small ps-3 mb-5">We provide innovative and scalable digital solutions.</p>
        <div className="row g-4">
                  {services.map((service, index) => {
                      const IconComponent = FaIcons[service.iconName];
                      return (
                          <div className="col-md-6 col-lg-3" key={index}>
                              <div className="service-card p-4 rounded shadow-sm h-100">
                                  <div className="service-icon mb-3"> {IconComponent && <IconComponent />}</div>
                                  <h5 className="fw-semibold mb-2">{service.title}</h5>
                                  <p className="text-muted">{service.description}</p>
                              </div>
                          </div>
                      )
                  }
                  )}
        </div>
      </div>
    </section>
  );
};

export default Services;
